import { castMembers } from '../data.js';

function CastCard({ member, index }) {
  return (
    <article className="cast-card">
      <div className="cast-photo">
        <img src={member.image} alt={`${member.name} headshot`} loading={index > 3 ? 'lazy' : 'eager'} />
        <span>{String(index + 1).padStart(2, '0')}</span>
      </div>
      <div className="cast-card-body">
        <p>{member.role}</p>
        <h2>{member.name}</h2>
        <span className="pronouns">{member.pronouns}</span>
        <details>
          <summary>Read bio <span aria-hidden="true">＋</span></summary>
          <p>{member.bio}</p>
        </details>
      </div>
    </article>
  );
}

export function CastPage() {
  return (
    <>
      <header className="page-hero page-width cast-heading">
        <div>
          <p className="eyebrow">Cast & fam</p>
          <h1>He’s making a list.<br />These people are on it.</h1>
        </div>
        <p>
          Performers, producers, musicians, technicians, and year-round agents of holiday destruction.
        </p>
      </header>

      <section className="cast-grid page-width" aria-label="Cast and creative team">
        {castMembers.map((member, index) => (
          <CastCard key={member.name} member={member} index={index} />
        ))}
      </section>
    </>
  );
}
